// extracted by mini-css-extract-plugin
export default {"wrapperAdvtCenter":"AdvtCenter_wrapperAdvtCenter__AMZMy","label":"AdvtCenter_label__kind8","qrWrapper":"AdvtCenter_qrWrapper__oc8y1","qrItem":"AdvtCenter_qrItem__eIj+o"};